{
  "general": {
    "title": "Confronta opzioni",
    "intro": "Uno sguardo rapido alla differenza tra Community, Abbonamento e Acquisto una tantum",
    "tableheader": "Abbonamento",
    "note1": "* Opzioni di acquisto in gruppo e sconto a volume disponibili.",
    "note2": "** Lingue supportate Dansk, Deutsch, English, Español, Suomi, Français, Italiano, Norsk, Polski, Português (Brasil), Русский, Svenska",
    "note3": "*** Richiede un account Community myboardmaker.com gratuito ed è esclusivamente per l'archivio delle attività."
  },
  "columnHeadings": {
    "community": "COMMUNITY",
    "onetime": "ACQUISTO UNA TANTUM*",
    "personal": "PRIVATO",
    "professional": "PROFESSIONISTA",
    "organization": "AZIENDA"
  },
  "mobileHeadings": {
    "community": "Community",
    "onetime": "Acquisto una tantum*",
    "personal": "Privato",
    "professional": "Professionista",
    "organization": "Azienda*"
  },
  "rowHeadings": {
    "editor": "Boardmaker 7 Editor",
    "activations": "Attivazioni",
    "languages": "Lingue**",
    "licensing": "Licenza",
    "pcsSymbols": "Simboli PCS",
    "templates": "Template",
    "studentCenter": "Boardmaker 7 Student Center",
    "playActivitiesInstructor": "Riproduci Attività come Istruttore",
    "playActivitiesStudent": "Riproduci Attività come Studente",
    "myBoardmaker": "myBoardmaker",
    "instructorManagement": "Gestione Istruttori",
    "studentManagement": "Gestione Studenti",
    "assignStudentActivities": "Assegna Attività Studenti",
    "cloudStorage": "Archivio Cloud",
    "createAndJoin": "Crea e unisciti ai Gruppi",
    "accessCommunity": "Accedi a più di 120 Attività della Community",
    "shareActivity": "Condividi le Attività in Community",
    "curriculum": "Curriculum e contenuto",
    "activitiesToGo": "Attività di Boardmaker da eseguire",
    "instructionalSolutions": "Instructional Solutions",
    "premiumActivities": "Attività premium",
    "coreFirstLearning": "Core First Learning"
  },
  "rowValues": {
    "byDevice": "2 dispositivi",
    "unlimited": "Illimitato",
    "byKey": "Codice Licenza",
    "symbols": "80.000+",
    "templates": "600+",
    "languages": "12",
    "login": "Accesso",
    "yes": "Sì",
    "yesNote": "Sì***",
    "no": "No"
  }
}